module.exports = __webpack_public_path__ + "img/menu-bottom-icon-polygon-outline.53aa8edf.svg";